(() => {
  const mountEmailConfirmation = () => {
    const nativeConfirmation = document.querySelector('.shopify-email-marketing-confirmation__container');
    const isSubscribeConfirmation = /\/account\/subscribe(?:\/|$)/.test(window.location.pathname);
    if ((!nativeConfirmation && !isSubscribeConfirmation) || document.querySelector('[data-early-confirmation]')) return;

    document.documentElement.classList.add('early-confirmation-page');
    document.title = 'Email confirmed - Early Run';

    const confirmation = document.createElement('main');
    confirmation.className = 'early-confirmation';
    confirmation.setAttribute('data-early-confirmation', '');
    confirmation.setAttribute('aria-labelledby', 'EarlyConfirmationTitle');
    confirmation.innerHTML = `
      <div class="early-confirmation__shell">
        <div class="early-confirmation__brand" aria-label="Early Run">
          <img src="${window.EarlyRunAssets?.primaryLogo || '/cdn/shop/t/6/assets/early-run-primary.svg'}" width="180" height="48" alt="Early Run">
        </div>
        <article class="early-confirmation__card">
          <div class="early-confirmation__success-mark" aria-hidden="true">&#10003;</div>
          <p class="early-confirmation__eyebrow">Submission complete</p>
          <h1 id="EarlyConfirmationTitle">Your application was submitted successfully.</h1>
          <p class="early-confirmation__lead">Your email is confirmed and your Early Run tester application is now in the manual-review queue. A registration confirmation email is on its way to your inbox.</p>
          <div class="early-confirmation__notice"><strong>Your tester registration is confirmed, not a product reservation or order.</strong><span>No unit has been reserved and no payment has been collected.</span></div>
          <p class="early-confirmation__status">You can close this page.</p>
        </article>
        <p class="early-confirmation__footer">Questions? Contact <a href="mailto:hello@earlyrunco.com">hello@earlyrunco.com</a>.</p>
      </div>`;

    if (nativeConfirmation) {
      nativeConfirmation.hidden = true;
      nativeConfirmation.parentNode.insertBefore(confirmation, nativeConfirmation);
      return;
    }

    const confirmationHost = document.querySelector('#MainContent') || document.querySelector('main') || document.body;
    confirmationHost.replaceChildren(confirmation);
  };

  mountEmailConfirmation();

  const applicationForms = Array.from(document.querySelectorAll('form[data-multistep-form]'));
  const interestFields = Array.from(document.querySelectorAll('[data-interest-choice]'));

  applicationForms.forEach((form) => {
    const noteField = form.querySelector('[data-application-note], [data-application-body]');
    const tagsField = form.querySelector('[data-application-tags]');
    const feedbackField = form.querySelector('[data-feedback-commitment]');
    const formInterestFields = Array.from(form.querySelectorAll('[data-interest-choice]'));
    const baseNote = noteField?.value.trim() || '';
    const baseTags = tagsField?.value.split(',').map((tag) => tag.trim()).filter(Boolean) || [];

    const syncApplicationBody = () => {
      const interests = formInterestFields.filter((field) => field.checked).map((field) => field.value);
      const feedbackCommitted = Boolean(feedbackField?.checked);

      if (noteField) {
        const lines = [
          baseNote,
          `Testing interests: ${interests.length ? interests.join(', ') : 'Not provided'}`,
          `Feedback commitment: ${feedbackCommitted ? 'Yes' : 'No'}`,
          'Consent version: v1',
        ].filter(Boolean);
        noteField.value = lines.join('\n');
      }

      if (tagsField) {
        const interestTags = interests.map((interest) => `interest-${interest.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`);
        const feedbackTag = feedbackCommitted ? 'committed-feedback' : 'feedback-pending';
        tagsField.value = [...new Set([...baseTags, ...interestTags, feedbackTag])].join(', ');
      }
    };

    form.addEventListener('submit', syncApplicationBody);
    formInterestFields.forEach((field) => field.addEventListener('change', syncApplicationBody));
    feedbackField?.addEventListener('change', syncApplicationBody);
    syncApplicationBody();
  });

  const updateInterestLimit = () => {
    const selected = interestFields.filter((field) => field.checked).length;
    interestFields.forEach((field) => {
      field.disabled = selected >= 2 && !field.checked;
    });
  };

  interestFields.forEach((field) => field.addEventListener('change', updateInterestLimit));
  updateInterestLimit();

  const gallery = document.querySelector('[data-product-gallery]');
  const gallerySlides = gallery ? Array.from(gallery.querySelectorAll('.current-test__figure')) : [];
  const galleryThumbs = Array.from(document.querySelectorAll('[data-gallery-index]'));

  if (gallery && gallerySlides.length && galleryThumbs.length) {
    const setActiveThumb = (activeIndex) => {
      galleryThumbs.forEach((thumb, index) => {
        if (index === activeIndex) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    };

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.galleryIndex);
        const slide = gallerySlides[index];
        if (!slide) return;
        gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
        setActiveThumb(index);
      });
    });

    let galleryTicking = false;
    gallery.addEventListener('scroll', () => {
      if (galleryTicking) return;
      galleryTicking = true;
      window.requestAnimationFrame(() => {
        const galleryLeft = gallery.getBoundingClientRect().left;
        const activeIndex = gallerySlides.reduce((closestIndex, slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - galleryLeft);
          const closestDistance = Math.abs(gallerySlides[closestIndex].getBoundingClientRect().left - galleryLeft);
          return distance < closestDistance ? index : closestIndex;
        }, 0);
        setActiveThumb(activeIndex);
        galleryTicking = false;
      });
    }, { passive: true });
  }

  const mobileApply = document.querySelector('.replica-mobile-apply');
  const mobileApplyLink = mobileApply?.querySelector('a');
  const primaryApply = document.querySelector('[data-primary-apply], .current-test__info > .button');
  const finalCta = document.querySelector('.replica-final-cta, .final-cta');
  const footer = document.querySelector('.site-footer');

  if (mobileApply && primaryApply && finalCta) {
    let primaryApplyVisible = true;
    let finalCtaVisible = false;
    let footerVisible = false;

    const updateMobileApply = () => {
      const shouldShow = !primaryApplyVisible && !finalCtaVisible && !footerVisible;
      mobileApply.classList.toggle('is-visible', shouldShow);
      mobileApply.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (mobileApplyLink) mobileApplyLink.tabIndex = shouldShow ? 0 : -1;
    };

    if ('IntersectionObserver' in window) {
      const applyObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === primaryApply) primaryApplyVisible = entry.isIntersecting;
          if (entry.target === finalCta) finalCtaVisible = entry.isIntersecting;
          if (entry.target === footer) footerVisible = entry.isIntersecting;
        });
        updateMobileApply();
      }, { threshold: 0.01 });

      applyObserver.observe(primaryApply);
      applyObserver.observe(finalCta);
      if (footer) applyObserver.observe(footer);
    } else {
      const updateFromViewport = () => {
        const primaryRect = primaryApply.getBoundingClientRect();
        const finalRect = finalCta.getBoundingClientRect();
        const footerRect = footer?.getBoundingClientRect();
        primaryApplyVisible = primaryRect.bottom > 0 && primaryRect.top < window.innerHeight;
        finalCtaVisible = finalRect.bottom > 0 && finalRect.top < window.innerHeight;
        footerVisible = Boolean(footerRect && footerRect.bottom > 0 && footerRect.top < window.innerHeight);
        updateMobileApply();
      };

      window.addEventListener('scroll', updateFromViewport, { passive: true });
      window.addEventListener('resize', updateFromViewport);
      window.setInterval(updateFromViewport, 250);
      updateFromViewport();
    }

    updateMobileApply();
  }
})();
